module.exports = __webpack_public_path__ + "static/img/GuitarPlayer2020 (2).e016f2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/GuitarPlayer2020 (2).png
// module id = 7SA0
// module chunks = 12